import { api } from './index'

// camelCase domain type (the API returns snake_case; we map explicitly below).
// image_url is null when a card has no image.
export type DashboardPromoCard = {
  imageUrl: string | null
  linkUrl: string
  position: number
}

type RawDashboardPromoCard = {
  image_url: string | null
  link_url: string
  position: number
}

type RawDashboardPromoCardsResponse = {
  dashboard_promo_cards: RawDashboardPromoCard[]
}

export const toPromoCard = (
  raw: RawDashboardPromoCard
): DashboardPromoCard => ({
  imageUrl: raw.image_url,
  linkUrl: raw.link_url,
  position: raw.position,
})

// The endpoint wraps the collection in a `dashboard_promo_cards` key and
// returns only the cards to show, already ordered by position. Unwrap and map
// to camelCase here so components never touch the wire shape, and default to an
// empty list if the key is ever absent.
export const toPromoCards = (raw?: {
  dashboard_promo_cards?: RawDashboardPromoCard[]
}): DashboardPromoCard[] => (raw?.dashboard_promo_cards ?? []).map(toPromoCard)

// Base URL already includes /merchants/:current_merchant_id (see api/utils.ts
// buildBaseUrl), so the path is relative to the merchant scope.
export const dashboardPromoCardsApi = api.injectEndpoints({
  endpoints: builder => ({
    getDashboardPromoCards: builder.query<DashboardPromoCard[], void>({
      query: () => 'dashboard_promo_cards',
      transformResponse: (raw: RawDashboardPromoCardsResponse) =>
        toPromoCards(raw),
      providesTags: ['DashboardPromoCards'],
    }),
  }),
  overrideExisting: false,
})

export const { useGetDashboardPromoCardsQuery } = dashboardPromoCardsApi
